import { Component, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'aux-drawer',
  templateUrl: 'drawer.component.html',
  styleUrls: ['drawer.component.scss'],
  imports: [CommonModule, MatButtonModule, MatIconModule, MatSidenavModule, MatToolbarModule],
})
export class AuxDrawerComponent {
  @ViewChild('drawer') drawer?: MatDrawer;
  @ViewChild('drawerContentRef', { read: ViewContainerRef })
  set drawerContentRef(value: ViewContainerRef) {
    this._drawerContentRef = value;
  }
  get drawerContentRef(): ViewContainerRef {
    return this._drawerContentRef;
  }
  private _drawerContentRef?: ViewContainerRef;

  protected title = '';

  close(): void {
    this._drawerContentRef?.clear();
    this.drawer?.close();
  }

  open(content: TemplateRef<any>, title?: string): void {
    if (this._drawerContentRef && this.drawer) {
      this._drawerContentRef.clear();
      this._drawerContentRef.createEmbeddedView(content);
      this.title = title || '';
      this.drawer.open();
    }
  }
}
